var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "16px",
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "esempio",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-LANDING",
    transform: "translate(-376.000000, -2731.000000)",
    fill: "#FCBB00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(230.000000, 2401.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.431864,340.619281 C145.717021,338.830996 148.324814,336.111476 150.039697,337.899762 L153.354688,341.356725 L163.685111,330.584712 C165.399954,328.796426 168.007787,331.515904 166.292944,333.304231 L154.658904,345.436524 C153.938458,346.187825 152.771557,346.187825 152.051071,345.436524 L147.431864,340.619281 Z",
    id: "Path-Copy-4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpli);
export default __webpack_public_path__ + "static/media/spli.0de6c6aceb8bc852dcbf62ac86e65203.svg";
export { ForwardRef as ReactComponent };